import * as React from "react";

const CheckIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    fill="none"
    viewBox="0 0 8 8"
    className={className}
  >
    <g clipPath="url(#clip0_3512_9769)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1.25 4.5 3 6.25l4-4"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_3512_9769">
        <path fill="currentColor" d="M0 0h8v8H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CheckIcon;
